import { CanvasModal, useCanvasRow } from "@zapier/canvases";
import { HydratedCanvas } from "@zapier/client";
import { useTranslations } from "@zapier/i18n";
import { FolderModal } from "@zapier/shared";
import { FOLDER_TRASH_ID } from "@zapier/utils";
import AssetRow from "./AssetRow";

interface Props {
  allowSelection?: boolean;
  canvas: HydratedCanvas;
  setCurrentModal: (modal: CanvasModal | FolderModal | undefined) => void;
  setCurrentCanvas: (canvas: HydratedCanvas | undefined) => void;
  folderId?: string;
  showLastRun?: boolean;
  showLocationColumn?: boolean;
  onCopyToAnotherAccount?: (asset: HydratedCanvas) => void;
}

export function AssetRowCanvas({
  allowSelection,
  canvas,
  setCurrentModal,
  setCurrentCanvas,
  folderId,
  showLastRun,
  showLocationColumn,
  onCopyToAnotherAccount,
}: Props) {
  const tShared = useTranslations("fallbacks");
  const { menuItems, permissions } = useCanvasRow({
    canvas,
    setCurrentModal,
    setCurrentCanvas,
    onCopyToAnotherAccount,
    isTrashed: folderId === FOLDER_TRASH_ID,
  });

  return (
    <AssetRow
      allowSelection={allowSelection}
      asset={canvas}
      folderZapTableRow={true}
      isUntitled={canvas?.name?.length === 0}
      menuItems={menuItems}
      onOpenMenu={permissions.enablePermissionsCheck}
      title={canvas.name || tShared("untitled-asset", { assetType: "Canvas" })}
      updatedAt={new Date(canvas.updatedAt)}
      folderId={folderId}
      showLastRun={showLastRun}
      showLocationColumn={showLocationColumn}
    />
  );
}
